// included features are enabled by default

module.exports = [
  'mark',
  'mkmk',
  'kern',
  'ccmp',
  'locl',
  'liga',
  'calt',
  'rclt',
  'rlig',
  'rvrn',
]
